import Component from './RichError.component';

export default Component;
